<template>
    <flex-container align-items="center">
        <flex-container
            direction="column"
            gap="xs"
            size="auto"
        >
            <text-heading>{{ props.title }}</text-heading>
            <text-decorator size="xs" :color="'gray-500'">
                {{ formatDate(props.interaction.createdAt) }}
            </text-decorator>
        </flex-container>
        <span v-if="wasSuccesful" v-tooltip="'Successvol verzonden'">
            <svg-icon
                :icon="IconBadgeCheck"
                :color="'green-500'"
                is-custom-icon
            />
        </span>
    </flex-container>

    <flex-container v-if="props.arguments" class="context">
        <div>
            <div>
                <strong>Aan: </strong>
                <span>{{ recipient }}</span>
            </div>
            <div>
                <strong>Onderwerp: </strong>
                <span>{{ subject }}</span>
            </div>
        </div>

        <div v-html="marked(body)" />
    </flex-container>
</template>

<script setup lang="ts">
    import type { Interaction } from '@keyvue/one-api-client';
    import dayjs from 'dayjs';
    import { computed } from 'vue';
    import { marked } from 'marked';
    import IconBadgeCheck from '@keyvue/one-awesome-icons/icons/regular/badge-check.svg?component';

    const props = defineProps<{
        title: string,
        interaction: Interaction,
        arguments: Record<string, any>,
        result: string,
    }>();

    const body = computed(() => {
        return props.interaction.context?.arguments?.body ?? '-';
    });

    const subject = computed(() => {
        return props.interaction.context?.arguments?.subject ?? '-';
    });

    const recipient = computed(() => {
        return props.interaction.context?.arguments?.recipient ?? '-';
    });

    const wasSuccesful = computed(() => {
        return props.interaction.context?.result === 'Email sent successfully';
    });

    function formatDate(date: Date) {
        return dayjs(date).format('DD MMMM YYYY HH:mm');
    }
</script>

<style scoped lang="scss">
    .context {
        background-color: color(gray-100);
        color: color(gray-800);
        padding: size(sm);
        border-radius: size(xs);
        white-space: break-spaces;
        max-width: 100%;
        box-sizing: border-box;
        font-size: 85%;
    }
</style>
